type ClientsPaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (updater: (page: number) => number) => void;
};

export function ClientsPagination({ page, totalPages, onPageChange }: ClientsPaginationProps) {
  return (
    <div className="flex items-center justify-between rounded-2xl border border-[var(--dash-line)] bg-white px-4 py-3">
      <span className="text-xs text-[var(--dash-muted)]">
        Page {page} of {totalPages}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={page <= 1}
          onClick={() => onPageChange((p) => p - 1)}
          className="rounded-xl border border-[var(--dash-line)] px-3 py-1.5 text-xs font-semibold text-[var(--dash-ink)] disabled:opacity-40"
        >
          Previous
        </button>
        <button
          type="button"
          disabled={page >= totalPages}
          onClick={() => onPageChange((p) => p + 1)}
          className="rounded-xl border border-[var(--dash-line)] px-3 py-1.5 text-xs font-semibold text-[var(--dash-ink)] disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}
